import { render, staticRenderFns } from "./TeacherCardDetailCloseButton.vue?vue&type=template&id=2450ac58&scoped=true&"
import script from "./TeacherCardDetailCloseButton.vue?vue&type=script&lang=js&"
export * from "./TeacherCardDetailCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCardDetailCloseButton.vue?vue&type=style&index=0&id=2450ac58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2450ac58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
